export const LOCAL_LOGIN_COMPLETE = "amplify-redirected-from-hosted-ui";
export const LOCAL_USER_DATA = "user-data";
